import { FC, useEffect, useRef, useState } from "react";
import styles from "./about.module.scss";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";
import Breadcrumbs from "../../componsnts/common/breadcrumbs/breadcrumbs";
import ScrollToTop from "../../componsnts/common/scroll-to-top/scroll-to-top";
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";

const AboutUs: FC = () => {
  const [containerClass, setContainerClass] = useState("container");

  const handleResize = () => {
    if (window.innerWidth < 992) {
      setContainerClass("container-fluid");
    } else {
    }

    if (window.innerWidth < 768) {
      setContainerClass("container");
    } else {
    }

    if (window.innerWidth > 992) {
      setContainerClass("container");
    } else {
    }
  };

  useEffect(() => {
    handleResize(); // 初始化时调用一次
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles["AboutUs_container"]}>
      <div className="banner_sec">
        <div className="banner_title_box">
          <div className="d-flex justify-content-center">
            <SectionTitle
              title="關於大創"
              titleColor="#fff"
              subTitle="ABOUT US"
              subTitleColor="rgba(0, 149, 217, 0.50)"
              backgroundColor="#0077AE"
              breadcrumbs={true}
            />
          </div>
        </div>

        <div className="banner_text_box">
          <div
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-once="false"
            className="banner_text"
          >
            大創電力為綠電能源品牌大創綠能子公司，是再生能源與智慧用電的整合專家，
            主要提供購
            售綠電與顧問服務，提供公開、公正的交易平台讓用戶自行選擇合作夥伴，
            同時透過自主開 發的 ai
            系統演算來協助綠電用戶提高綠電的使用效率達到雙贏局面，
            一併滿足綠電用戶與
            旗下供應鏈的減碳目標與永續需求！一同與用戶們達成環境永續與淨零碳排的最終目標。
          </div>
        </div>
      </div>

      <section className="section_2">
        <div className={containerClass}>
          <div
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-once="false"
            className="row"
          >
            <div className="col-md-6 col-sm-12 content_box  order-last order-md-first">
              <div className="sec_title">WE CARE</div>
              <div className="sec_text">
                我們期盼透過綠電來降低碳排； 減少並解決目前地球生態環境隨著氣候
                改變而越來越窘迫的情景，
                我們希望為提高環境最佳永續化盡一份心力。
              </div>
            </div>
            <div className="col-md-6 col-sm-12 img_box ">
              <img
                className="img"
                src="/assets/images/about-us/compressed/sec_1.png"
                alt="sec1-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section_3">
        <div className={containerClass}>
          <div
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-once="false"
            className="row"
          >
            <div className="col-md-6 col-sm-12 img_box">
              <img
                className="img"
                src="/assets/images/about-us/compressed/sec_2.png"
                alt="sec2-img"
              />
            </div>

            <div className="col-md-6 col-sm-12 content_box">
              <div className="sec_title">PROSPECTS</div>
              <div className="sec_text">
                大創電力目標不僅以公開、公正為執行目標；
                我們同時為協助企業完成所訂立的目標，
                大創團隊將成立專案小組、並透過 AI 計算
                來協助企業取得最完善的綠電配方！
                近年來碳排放的議題討論聲浪越來越大，
                大創電力期盼透過各樣智能用電的方式與各
                方合作夥伴一同成長、去完成目標！
              </div>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop></ScrollToTop>
    </div>
  );
};
export default AboutUs;
